// extracted by mini-css-extract-plugin
export default {"buttons-container":"LoadingIndicator_buttons-container__5R59G","align-center":"LoadingIndicator_align-center__zniEk","loadingIndicator":"LoadingIndicator_loadingIndicator__xt9GI"};